import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import ServiceAreas from "./sections/ServiceAreas";
import FAQ from "./sections/FAQ";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactForm />
      <ServiceAreas />
      <FAQ />
      <Footer />
    </div>;
}